<div class="d-flex vw-100 vh-100">
  <div class="spinner-border text-primary m-auto" role="status">
    <span class="visually-hidden">Redirecting...</span>
  </div>
</div>
